// "M/S." (and "Messrs.") is a standard Indian business-name prefix, not part
// of the company's actual name — without stripping it, "M/S. GJA GRANITES"
// (as an invoice's letterhead reads it) never matches an existing roster
// entry saved as plain "GJA GRANITES", so a real, already-known trade
// partner gets flagged as brand new on every import/entry that happens to
// include the honorific.
const NAME_PREFIX = /^(m\/s\.?|messrs\.?)\s*/i;

// Normalizes a vendor/customer name for roster-matching comparisons — used
// wherever we need to decide "is this the same company as one already on
// file?" (PartyMatchCard's invoice-import matching, AccountsPage's manual
// "Add supplier/customer" duplicate check). Keep both call sites on this one
// implementation rather than copies, so a fix to the comparison rules only
// has to happen once.
export const normalizePartyName = (name: string) =>
  name
    .trim()
    .replace(NAME_PREFIX, '')
    .replace(/[.,]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
